import { useState, useEffect } from 'react'
import styles from '../../../pages/LeadCapture/LeadCaptureConfig/LeadCaptureConfig.module.css'
// Font Awesome assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faSquareCheck, faTrashCan, faSquareXmark } from '@fortawesome/free-solid-svg-icons'

// image elements
const pencil = <FontAwesomeIcon icon={faPencil} />
const trash = <FontAwesomeIcon icon={faTrashCan} />
const squareCheck = <FontAwesomeIcon icon={faSquareCheck} />
const squareXmark = <FontAwesomeIcon icon={faSquareXmark} />
const LCProduct = ({ index, productItem, editProduct, deleteProduct, cancelEdit, submitEdit, editingId, groups, attachments, defaultProducts, skus }) => {

    const [formData, setFormData] = useState(
        {
            id: null,
            skuName: null,
            sku: {},
            name: null,
            description: null,
            regularPrice: null,
            onSitePrice: null,
            showQuantity: null,
            productGroups: null,
            productGroupsName: null,
            productOrdering: null,
            pdfAttachment: null,
            usePromoCode: null,
            promoCodes: null,
            isAdmin: null,
        }
    )

    const changeGroupName = groupNumber => {
        const items = Array.from(groups)
        let filtered = items[groupNumber]
        return filtered && filtered!== undefined ? filtered.name : null;
    }
    const isEditInvalid = () => {
        return !(productItem.name && productItem.sku);
    }
    const submitEditChange = async e => {
        e.preventDefault()
        submitEdit(e, formData);
    }
    const limitText = ( strText, lenLimit ) => {
        let result = ''
        if (strText && strText.length > lenLimit) {
            result = strText.substring(0, lenLimit);
            result += '...';
        }
        else {
            result = strText;
        }
        return result;
    }
    const handleChange = (e) => {
        if (e.target.type === 'select-one') {
            if (e.target.name === "productGroupsName") {
                var foundGroup = groups.find((item) => item.name === e.target.value);
                if (foundGroup) {
                    formData.group = foundGroup;
                    formData.productGroups = foundGroup.id;
                    formData.productGroupsName = foundGroup.name
                }
                else {
                    formData.group = null;
                    formData.productGroups = null;
                }
            }
            else if (e.target.name === "pdfAttachment") {
                var foundAttachment = attachments.find((item) => item.fileName === e.target.value);
                if (foundAttachment) {
                    formData.pdfAttachment = foundAttachment.fileName;
                }
                else {
                    formData.pdfAttachment = null;
                }
            }
            else {
                var foundProduct = defaultProducts.find((item) => item.skuName === e.target.value);
                if (foundProduct) {
                    formData.sku = foundProduct;
                }
                else {
                    formData.sku = null;
                }
                formData.skuName = foundProduct.skuName
            }
            setFormData({
                ...formData
            })
        }
        else if (e.target.type === 'checkbox') {
            formData[e.target.name] = e.target.checked;
            setFormData({
                ...formData
            })
        }
        else if (e.target.type === 'number') {
            formData[e.target.name] = parseInt( e.target.value);
            setFormData({
                ...formData
            })
        }
        else {
            formData[e.target.name] = e.target.value;
            setFormData({
                ...formData
            })
        }
    }
    useEffect(() => {
        if (skus && skus.length > 0 && groups && groups.length > 0 && attachments && attachments.length > 0) {
            if (productItem.skuName && productItem.skuName !== undefined) {
                var foundSKU = skus.find((item) => item.name === productItem.skuName);
                if (foundSKU) {
                    productItem.sku = foundSKU;
                }
                else {
                    productItem.sku = null;
                }
            }
            if (/*productItem.productGroups && */productItem.productGroups !== undefined) {
                var foundGroup = groups.find((item) => item.id === productItem.productGroups);
                if (foundGroup) {
                    productItem.group = foundGroup;
                    productItem.productGroupsName = foundGroup.name;
                }
                else {
                    productItem.group = null;
                    productItem.productGroupsName = null;
                }
            }
            if (productItem.pdfAttachment && productItem.pdfAttachment !== undefined) {
                var foundAttachment = attachments.find((item) =>
                    item.fileName.toLowerCase() === productItem.pdfAttachment.toLowerCase());
                if (foundAttachment) {
                    productItem.attachment = foundAttachment;
                    productItem.pdfAttachment = foundAttachment.fileName;
                }
                else {
                    productItem.attachment = null;
                    productItem.pdfAttachment = null;
                }
            }
            setFormData(productItem);
            //setFormData({
            //    ...productItem
            //})
        }
         
    }, [editingId])
    return (
        <>
            {editingId !== index.toString() ?
                <tr className={styles.trProducts} >
                    <td className={styles.tdProducts}> {productItem.skuName}</td>
                    <td className={styles.tdProducts}> {productItem.name}</td>
                    <td className={styles.tdProducts}> {limitText(productItem.description, 110)}</td>
                    <td className={styles.tdProducts}> {productItem.regularPrice}</td>
                    <td className={styles.tdProducts}> {productItem.onSitePrice}</td>
                    <td className={styles.tdProducts}> {productItem.showQuantity && productItem.showQuantity !== undefined && productItem.showQuantity ? "Yes" : "No"}</td>
                    <td className={styles.tdProducts}> {changeGroupName(productItem.productGroups)}</td>
                    <td className={styles.tdProducts}> {productItem.productOrdering}</td>
                    <td className={styles.tdProducts}> {limitText(productItem.pdfAttachment, 25)}</td>
                    <td className={styles.tdProducts}> {productItem.usePromoCode && productItem.usePromoCode !== undefined && productItem.usePromoCode ? "Yes" : "No"}</td>
                    <td className={styles.tdProducts}> {productItem.promoCodes}</td>
                    <td className={styles.tdProducts}> {productItem.isAdmin && productItem.isAdmin !== undefined && productItem.isAdmin ? "Yes" : "No"}</td>
                    <td className={styles.tdProducts}>
                        <button className={styles.editButton} onClick={e => editProduct(e)} id={index} title="Edit product.">
                            <i className={styles.buttonImage}>{pencil}</i>
                        </button>
                        <button className={styles.editButton} onClick={e => deleteProduct(e)} id={index} title="Delete product.">
                            <i className={styles.buttonImage}>{trash}</i>
                        </button>
                    </td>
                </tr>
                :
                <tr className={styles.trProducts} >
                    <td className={styles.tdProducts}>
                        <select
                            name="skuName"
                            id={styles.ThirdPartyListDropdown}
                            value={formData.skuName}
                            onChange={handleChange}
                            className={styles.fitCell}
                    >
                        <option disabled={true} value="" selected="selected">
                            -- Select an option --
                        </option>
                        {
                                defaultProducts.map((ci, idx) => (
                                <option key={idx}>{ci.skuName}</option>
                            ))
                        }
                    </select></td>
                    <td className={styles.tdProducts}>
                        <label title="Product display name.">
                            Display Name: <input
                                type="text"
                                value={formData.name}
                                name="name"
                                onChange={handleChange}
                                className={styles.fitCell}
                            />

                        </label>
                    </td>
                    <td className={styles.tdProducts}>
                        <label title="Product description.">
                            Description: <textarea
                                type="text"
                                value={formData.description}
                                name="description"
                                onChange={handleChange}
                                rows="4"
                                cols="40"
                                className={styles.fitCell}
                            />

                        </label>
                    </td>
                    <td className={styles.tdProducts}>
                        <label title="Product regular price.">
                            Regular Price: <input
                                type="number"
                                value={formData.regularPrice}
                                name="regularPrice"
                                onChange={handleChange}
                                className={styles.fitCell}
                            />

                        </label>
                    </td>
                    <td className={styles.tdProducts}>
                        <label title="Product onsite price.">
                            Onsite Price: <input
                                type="number"
                                value={formData.onSitePrice}
                                name="onSitePrice"
                                onChange={handleChange}
                                className={styles.fitCell}
                            />

                        </label>
                    </td>
                    <td className={styles.tdProducts}>
                        <label title="Allow quantity selection.">
                            Show Quantity: <input
                                type="checkbox"
                                checked={formData.showQuantity}
                                name="showQuantity"
                                onChange={handleChange}
                                className={styles.fitCell}
                            />

                        </label>
                    </td>

                    <td className={styles.tdProducts}>
                        <label title="Product display group.">
                            Product Group:
                            <select
                                name="productGroupsName"
                                id={styles.ThirdPartyListDropdown}
                                value={formData.productGroupsName}
                                onChange={handleChange}
                                className={styles.fitCell}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    groups.map((ci, idx) => (
                                        <option key={idx}>{ci.name}</option>
                                    ))
                                }
                            </select>
                        </label>
                    </td>
                    <td className={styles.tdProducts}>
                        <label title="Product group order.">
                             Product Group Order: <input
                                type="number"
                                value={formData.productOrdering}
                                name="productOrdering"
                                onChange={handleChange}
                                className={styles.fitCell}
                            />

                        </label>
                    </td>
                    <td className={styles.tdProducts}>
                        <label title="PDF name.">
                            PDF Attachment: 
                            <select
                                name="pdfAttachment"
                                id={styles.ThirdPartyListDropdown}
                                value={formData.pdfAttachment}
                                onChange={handleChange}
                                className={styles.fitCell}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    attachments.map((ci, idx) => (
                                        <option key={idx}>{ci.fileName}</option>
                                    ))
                                }
                            </select>

                        </label>
                    </td>
                    <td className={styles.tdProducts}>
                        <label title="Allow promo codes.">
                            Use Promo Code: <input
                                type="checkbox"
                                checked={formData.usePromoCode}
                                name="usePromoCode"
                                onChange={handleChange}
                                className={styles.fitCell}
                            />

                        </label>
                    </td>
                    <td className={styles.tdProducts}>
                        <label title="Promo codes.">
                            Promo Code: <input
                                type="text"
                                value={formData.promoCodes}
                                name="promoCodes"
                                onChange={handleChange}
                                className={styles.fitCell}
                            />

                        </label>
                    </td>
                    <td className={styles.tdProducts}>
                        <label title="True - admin access only.">
                            Is Admin: <input
                                type="checkbox"
                                checked={formData.isAdmin}
                                name="isAdmin"
                                onChange={handleChange}
                                className={styles.fitCell}
                            />

                        </label>
                    </td>
                    <td className={styles.tdAccounts}>
                        <button onClick={e => cancelEdit(e)} id={index} className={styles.editButtons} title="Cancel Edit">
                            <i className={styles.buttonImage} id={styles.editCancel}>
                                {squareXmark}
                            </i>
                        </button>
                        <button onClick={e => submitEditChange(e)} id={index} className={styles.editButtons} disabled={isEditInvalid()} title="Submit Edit">
                            <i className={styles.buttonImage} id={styles.editSubmit}>
                                {squareCheck}
                            </i>
                        </button>
                    </td>
                </tr>
            }
        </>
    );
}

export default LCProduct;